import { InjectionToken } from '@angular/core';
import { Environment } from '@libs/core/types';

export const APP_ENVIRONMENT = new InjectionToken<Environment>('Application environmental variables');
